export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "exported_batch": {
            "packing_house_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso de empaque"])},
            "crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])}
          }
        }
      }
    }
  })
}